export const ENABLE_MAINTENANCE_BANNER = "ENABLE_MAINTENANCE_BANNER";
export const INITIAL_MAINTENANCE_CHECK_COMPLETED =
  "INITIAL_MAINTENANCE_CHECK_COMPLETED";
export const SHOW_MAINTENANCE_BANNER = "SHOW_MAINTENANCE_BANNER";
export const GET_DOWNTIME_DETAILS = "GET_DOWNTIME_DETAILS";
export const GET_DOWNTIME_DETAILS_INPROGRESS =
  "GET_DOWNTIME_DETAILS_INPROGRESS";
export const GET_DOWNTIME_DETAILS_ERROR = "GET_DOWNTIME_DETAILS_ERROR";
export const GET_DOWNTIME_DETAILS_SUCCESS = "GET_DOWNTIME_DETAILS_SUCCESS";
